import valid from "card-validator";

export function formatCardNumber(value: string): string {
  const digits = value.replace(/\D/g, "");
  const isAmex = digits.startsWith("34") || digits.startsWith("37");

  if (isAmex) {
    const limited = digits.slice(0, 15);
    return limited
      .replace(/(\d{4})(\d)/, "$1 $2")
      .replace(/(\d{4} \d{6})(\d)/, "$1 $2")
      .trim();
  }

  const limited = digits.slice(0, 16);
  return limited.replace(/(.{4})/g, "$1 ").trim();
}

export function formatExpiry(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 4);

  if (digits.length <= 1) return digits;
  if (digits.length === 2) return `${digits}/`;
  return `${digits.slice(0, 2)}/${digits.slice(2)}`;
}

export function detectCardBrand(number: string): string {
  const cleaned = number.replace(/\D/g, "");
  if (!cleaned) return "unknown";
  return valid.number(cleaned).card?.type ?? "unknown";
}

export function validateCardNumber(number: string): {
  isValid: boolean;
  isPotentiallyValid: boolean;
} {
  const cleaned = number.replace(/\D/g, "");
  const result = valid.number(cleaned);
  return {
    isValid: result.isValid,
    isPotentiallyValid: result.isPotentiallyValid,
  };
}

export function getMaxCvcLength(brand: string): number {
  return brand === "american-express" ? 4 : 3;
}
